import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 13/12;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Docs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Doc" transform="translate(-435.000000, -273.000000)">
                <g id="Group-10" transform="translate(421.000000, 180.000000)">
                    <g id="Group-7" transform="translate(14.000000, 90.000000)">
                        <g id="Group-8" transform="translate(0.000000, 3.000000)">
                            <path d="M1.3,0.652772315 C1.3,0.29225612 1.58901006,2.30926389e-14 1.95056658,2.30926389e-14 L11.0494334,2.30926389e-14 C11.4087314,2.30926389e-14 11.7,0.293133867 11.7,0.652772315 L11.7,3.24722769 C11.7,3.60774388 11.4109899,3.9 11.0494334,3.9 L1.95056658,3.9 C1.59126858,3.9 1.3,3.60686613 1.3,3.24722769 L1.3,0.652772315 Z M2.6,1.3 L2.6,2.6 L10.4,2.6 L10.4,1.3 L2.6,1.3 Z M1.3,8.45277231 C1.3,8.09225612 1.58901006,7.8 1.95056658,7.8 L11.0494334,7.8 C11.4087314,7.8 11.7,8.09313387 11.7,8.45277231 L11.7,11.0472277 C11.7,11.4077439 11.4109899,11.7 11.0494334,11.7 L1.95056658,11.7 C1.59126858,11.7 1.3,11.4068661 1.3,11.0472277 L1.3,8.45277231 Z M2.6,9.1 L2.6,10.4 L10.4,10.4 L10.4,9.1 L2.6,9.1 Z" id="Combined-Shape" fill={color}></path>
                            <path d="M0,5.7 C0,5.42385763 0.289750444,5.2 0.649119777,5.2 L12.3508802,5.2 C12.7093792,5.2 13,5.42193241 13,5.7 C13,5.97614237 12.7102496,6.2 12.3508802,6.2 L0.649119777,6.2 C0.290620824,6.2 0,5.97806759 0,5.7 Z" id="Path" fill="#009084"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconFormatLineSeparator extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
